import { Layout } from 'antd';
import Image from 'next/legacy/image';
import Link from 'next/link';

import { StyledPublicPageFooter } from './PublicPageFooter.styled';
import dayjs from 'dayjs';
export default function PublicPageFooter({}) {
  const { Footer } = Layout;

  return (
    <StyledPublicPageFooter>
      <Footer className="public-page-footer">
        {/* <div className="rockalingua-foundation">
          <Image
            className="main-image"
            src={'/img/world.svg'}
            alt="Rockalingua foundation"
            width={67}
            height={66}
          />
          <div className="text">
            <h2 className="title">Rockalingua Foundation</h2>
            <p>We donate 10% of all our profits to good causes.</p>
          </div>
        </div> */}
        <div className="footer-links">
          <div className="content-types">
            <h3 className="title">Content types</h3>
            <ul>
              <li>
                <Link href="/themes">Themes</Link>
              </li>
              <li>
                <Link href="/videos">Videos</Link>
              </li>
              <li>
                <Link href="/games">Games</Link>
              </li>
              <li>
                <Link href="/songs">Songs</Link>
              </li>
              <li>
                <Link href="/interactive-videos">Videos with questions</Link>
              </li>
              <li>
                <Link href="/short-stories">Short stories</Link>
              </li>
              <li>
                <Link href="/worksheets">Worksheets</Link>
              </li>
              <li>
                <Link href="/picture-dictionaries">Picture dictionaries</Link>
              </li>
              <li>
                <Link href="/crafts">Crafts</Link>
              </li>
            </ul>
          </div>
          <div className="More stuff">
            <h3 className="title">More stuff</h3>
            <ul>
              {/* <li>
                <Link href="/">
                  <a>Teaher Pro info</a>
                </Link>
              </li> */}
              {/*  <li>
                <Link href="/">
                  <a>Store</a>
                </Link>
              </li> */}
              <li>
                <Link href="/blog">Blog</Link>
              </li>
              <li>
                <Link href="/about">Who we are</Link>
              </li>
              {/* <li>
                <Link href="/">
                  <a>Contact</a>
                </Link>
              </li> */}
            </ul>
          </div>
          <div className="your-account">
            <h3 className="title">Your account</h3>
            <ul>
              <li>
                <Link href="/student/enrollment">Join your class</Link>
              </li>
              <li>
                <Link href="/login">Log in</Link>
              </li>
              <li>
                <Link href="/sign-up">Sign up</Link>
              </li>
              <li>
                <Link href="/sign-up">Renew subscription</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="social-media-and-legal">
          <div className="wrapper">
            <div className="logo-legal">
              <div className="logo">
                <Link href="/" passHref>
                  <Image
                    src={
                      process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST +
                      '/img/rockaLogo.png'
                    }
                    alt="Rockalingua logo"
                    layout="fill"
                  />
                </Link>
              </div>

              <div className="legal">
                <span className="copyright">
                  © {dayjs().year()} Rockalingua
                </span>
                <Link href="/legal/termsOfUse">Legal </Link>
                <Link href="/legal/privacyPolicy">Privacy policy</Link>
                <Link href="/legal/fulfillmentPolicy">Fulfillment policy</Link>
              </div>
            </div>
          </div>
        </div>
      </Footer>
    </StyledPublicPageFooter>
  );
}
